// src/components/sections/CapabilitiesSection.js
import React from 'react';
import CapabilityCard from '../CapabilityCard'; // Import the card component

function CapabilitiesSection({ capabilities }) {
  // Ensure capabilities is an array before mapping
  if (!Array.isArray(capabilities)) {
    console.warn("CapabilitiesSection: capabilities prop is not an array.");
    return null; // Or render some fallback UI
  }

  return (
    <section id="capabilities" className="py-20 bg-gray-100 scroll-mt-16">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">Our Capabilities</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
          {capabilities.map((cap, index) => (
            // Ensure each capability has an icon component
            cap.icon ? (
                <CapabilityCard
                key={index}
                category={cap.category}
                skills={cap.skills}
                Icon={cap.icon} // Pass the specific icon component
                />
            ) : null // Skip rendering if icon is missing
          ))}
        </div>
      </div>
    </section>
  );
}

export default CapabilitiesSection;
